import API from "@/api";
import defaultState from "./state";
import { DO_LOGIN, DO_LOGOUT, SET_AUTENTICACAO, GET_TOURS, SET_LISTTOURS, SAVE_TOURS_USUARIO, UPDATE_TOURTODO} from "./types";
import tourApi from "@/api";

export default {
	[DO_LOGIN]({ commit }, payload) {
		return new Promise((resolve, reject) => {
			API.fazerLogin(payload.login)
				.then((res) => {
					commit(SET_AUTENTICACAO, res.data.result);

					resolve();
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	[DO_LOGOUT]({ commit }) {
		return new Promise((resolve, reject) => {
			commit(SET_AUTENTICACAO, {
				...defaultState,
			});

			resolve();
		});
	},
	[GET_TOURS]({ commit }) {
		return new Promise((resolve, reject) => {
			tourApi.getAllTours().then((response) => {
			let data = response.data
			if (data.statusCode == 200) {
				commit(SET_LISTTOURS, data.result);
				resolve(response);
			} else {
				reject(data);
			}
			}).catch(error => reject(error))
		})
    },
	[SAVE_TOURS_USUARIO]({ commit, state }, listIdTour) {
		let aux = listIdTour.map(item => item.id);
		let data = { 'listIdTour': aux, 'login': state.email };
		return new Promise((resolve, reject) => {        
			tourApi.saveUserTour(data)
			.then(response => {
				let data = response.data;
				if (data.statusCode == 200) {
				commit(UPDATE_TOURTODO, aux);
				resolve(data);
				} else {
				reject(data);
				}
			})
			.catch(error => {
				reject(error);
			});
		});
    },
};
